/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';

import { ApiResponse, apiVisitor } from '@/api/api';
import { DEMO_URLS } from '@/api/url';
import { CandidateExperienceLevel } from '@/types/enums/CandidateExperienceLevel';
import { AlertsAndFollowUpQuestion, ResumeAnalysisResult } from '@/types/AnalysisResult';
import { AnalysisProvider } from '@/types/AnalysisProvider';

export interface AnalyzeTrialResumePayload {
  resume_file: File;
  jd_file?: File;
}

export interface AnalyzeTrialResumeResponse {
  resume_data: Resume;
  experience_level: CandidateExperienceLevel;
  fit_job_positions: string[];
  analysis_result: ResumeAnalysisResult | null;
  follow_up_items: AlertsAndFollowUpQuestion[];
}

export const apiAnalyzeTrialResume = async ({
  payload
}: {
  payload: AnalyzeTrialResumePayload;
}): Promise<ApiResponse<AnalyzeTrialResumeResponse>> => {
  try {
    const formData = new FormData();
    formData.append('resume_file', payload.resume_file);

    if (payload.jd_file) {
      formData.append('jd_file', payload.jd_file);
    }

    const response = await apiVisitor.post<ApiResponse<AnalyzeTrialResumeResponse>>(
      DEMO_URLS.EXTRACT_RESUME,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiGetTrialExtractorProviders = async (): Promise<ApiResponse<AnalysisProvider[]>> => {
  try {
    const response = await apiVisitor.get<ApiResponse<AnalysisProvider[]>>(
      DEMO_URLS.GET_EXTRACTOR_PROVIDERS
    );
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
